/**
 * Consulta o histórico de pausas da Ordem de Serviço pela RPC protegida.
 *
 * RELEASE: 2026-10-09 v1.0.0 - Criação da fonte única da aba Pausas.
 */
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/hooks/useAuth';

const rpc = (name: string, args: Record<string, unknown>) => (supabase.rpc as any).call(supabase, name, args);

export interface ServiceOrderPause {
  id: string;
  paused_by: string;
  paused_by_name: string | null;
  paused_at: string;
  resumed_by: string | null;
  resumed_by_name: string | null;
  resumed_at: string | null;
  reason: string | null;
  duration_seconds: number;
}

/** Carrega pausas e calcula os totais exibidos no resumo da aba. */
export function useServiceOrderPauses(serviceOrderId: string) {
  const { currentTenant } = useAuth();
  const query = useQuery({
    queryKey: ['service-orders', 'pauses', currentTenant?.id, serviceOrderId],
    enabled: !!currentTenant?.id && !!serviceOrderId,
    queryFn: async () => {
      const { data, error } = await rpc('get_service_order_pauses', {
        p_id: serviceOrderId,
        p_tenant_hint: currentTenant?.id,
      });
      if (error) throw error;
      return (data ?? []) as ServiceOrderPause[];
    },
  });
  const pauses = query.data ?? [];
  return {
    pauses,
    totalCount: pauses.length,
    totalDurationSeconds: pauses.reduce((total, pause) => total + (pause.duration_seconds || 0), 0),
    isLoading: query.isLoading,
    error: query.error,
  };
}